import VueCookies from 'vue-cookies';
//是否登录
export const islogin = (p) => {
	return VueCookies.get("token") && VueCookies.get("userinfo") ? true : false;
}; 
export const safeback = (p) => {
	if (window.history.length > 1) {
		// 如果有历史页面，返回上一页
		history.go(-1);
	} else {
		// 如果没有历史页面，跳转到 /
		window.location.href = '/';
	}
}
export const timeFormat = (p) => {
	//x小时x分钟x秒后取消订单
	let hour=0;
	let minute=0;
	let second=0;
	let time=p;
	let str=''
	if(time>=3600){
		hour=Math.floor(time/3600);
		time=time%3600;
		str=hour+" 小时 ";
	}
	if(time>=60){
		minute=Math.floor(time/60);
		time=time%60;
		str+=minute+" 分钟 ";
	}
	second=time;
	str+=second+" 秒后取消";
	return str;
}